/** Strip BOM and normalize newlines so frontmatter parsing matches CRLF / CR / LF. */
export function normalizeMarkdownForFrontmatterParse(text: string): string {
  let s = text;
  if (s.charCodeAt(0) === 0xfeff) {
    s = s.slice(1);
  }
  return s.replace(/\r\n/g, "\n").replace(/\r/g, "\n");
}

/** Remove the leading YAML frontmatter block, leaving the markdown body. */
export function stripSkillMdFrontmatter(fullText: string): string {
  const text = normalizeMarkdownForFrontmatterParse(fullText);
  const match = text.match(/^---\s*\n[\s\S]*?\n---\s*\n?/);
  return match ? text.slice(match[0].length) : text;
}

/**
 * Unwrap YAML single/double-quoted scalars and decode common double-quote escapes.
 */
export function unquoteYamlScalar(value: string): string {
  let s = value.trim();
  if (s.length >= 2) {
    if (s.startsWith('"') && s.endsWith('"')) {
      s = s.slice(1, -1);
      return s
        .replace(/\\"/g, '"')
        .replace(/\\\\/g, "\\")
        .replace(/\\n/g, "\n")
        .replace(/\\r/g, "\r")
        .replace(/\\t/g, "\t");
    }
    if (s.startsWith("'") && s.endsWith("'")) {
      s = s.slice(1, -1);
      return s.replace(/''/g, "'");
    }
  }
  return s;
}

/**
 * Replace the markdown body after the first YAML frontmatter block, preserving the
 * frontmatter verbatim. Used to save SKILL.md body edits — frontmatter itself is
 * owned by the server (composed at create, rewritten on description updates).
 */
export function replaceBodyInMarkdown(
  fullText: string,
  newBody: string,
): string {
  const text = normalizeMarkdownForFrontmatterParse(fullText);
  const m = text.match(/^---\s*\n[\s\S]*?\n---[ \t]*\n?/);
  if (!m) {
    throw new Error("SKILL.md is missing frontmatter.");
  }
  const frontmatter = m[0].replace(/\n*$/, "\n");
  return `${frontmatter}\n${newBody.trim()}\n`;
}

export function zipPathDirname(path: string): string {
  const n = path.replace(/\\/g, "/");
  const idx = n.lastIndexOf("/");
  if (idx < 0) {
    return "";
  }
  return n.slice(0, idx + 1);
}

/** Path inside the skill root for S3 `file_name` (no leading ./). */
export function toRelativeSkillFilePath(
  zipEntryPath: string,
  stripPrefix: string,
): string {
  const p = zipEntryPath.replace(/\\/g, "/");
  const prefix = stripPrefix.replace(/\\/g, "/");
  let rel = prefix ? p.slice(prefix.length) : p;
  rel = rel.replace(/^\.\/+/, "");
  return rel;
}
